var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.$router.push(_vm.route)}}},[_c('md-icon',{attrs:{"id":"Ic_Arrow"}},[_vm._v("arrow_back")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c67bc20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/ifdef-loader/ifdef-loader.js??ref--2-0!./src/components/BackButton.vue
// module id = null
// module chunks = 